import TApiResult from "../../../types/api/TApiResult";
import { TApiMemberIconNicknameUpdateValidateErrors } from "../postMemberIconNicknameUpdate";
import { TApiMemberUpdateValidateErrors } from "../postMemberUpdate";

const tokenNotFoundWithValidateErrors: Promise<
  TApiResult & TApiMemberUpdateValidateErrors & TApiMemberIconNicknameUpdateValidateErrors
> = new Promise((resolve, reject) =>
  resolve({
    isSuccess: false,
    status: 401,
    message: "tokenNotFound",
    validateErrors: [],
  })
);

export default tokenNotFoundWithValidateErrors;
